import { render, staticRenderFns } from "./table-task-info.vue?vue&type=template&id=4d52bf0b"
import script from "./table-task-info.vue?vue&type=script&lang=js"
export * from "./table-task-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports